module.exports = __webpack_public_path__ + "static/media/cowork.a0386de1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cowork.jpeg
// module id = 504
// module chunks = 1